import React, { useContext, useEffect } from 'react'
import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs'
import Content from '../Content/Content'
import VerticalDetailsContextProvider from 'store/verticalsDetails/Context'
import Details from 'containers/VerticalPage/nft/Details/Details'
import { CurrentZone } from 'utils/types'
import { useSelector } from 'react-redux'
import { selectCurrentZone } from 'store/global'
import { changeCurrentZoneIndexesFunc } from 'containers/VerticalPage/common/utils'
import { VerticalContext } from 'store/verticals/Context'
import styles from './VerticalPage.module.scss'

const VerticalPage = (props: { changeCurrentZoneIndexes: changeCurrentZoneIndexesFunc }) => {
  const currentZone: CurrentZone = useSelector(selectCurrentZone)
  const { verticalEntity } = useContext(VerticalContext)

  useEffect(() => {
    props.changeCurrentZoneIndexes({
      baseIndices: currentZone?.cryptoIndices,
      activityIndices: currentZone?.cryptoActivityIndices,
    })
  }, [currentZone])

  return (
    <div className={styles.container}>
      <Breadcrumbs
        containerSx={styles.breadcrumbsStyles}
        data={[
          { label: 'Home', href: '/' },
          { label: 'Crypto', href: '/crypto' },
          { label: verticalEntity?.entityDetails.name || 'N/A' },
        ]}
      />
      <Content />
      <VerticalDetailsContextProvider>
        <Details />
      </VerticalDetailsContextProvider>
    </div>
  )
}

export default VerticalPage
